import { render } from "./QHLSOperation.vue?vue&type=template&id=1db3b815&scoped=true"
import script from "./QHLSOperation.vue?vue&type=script&lang=js"
export * from "./QHLSOperation.vue?vue&type=script&lang=js"

import "./QHLSOperation.vue?vue&type=style&index=0&id=1db3b815&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db3b815"]])

export default __exports__